// extracted by mini-css-extract-plugin
export default {"Folder":"Folder_Folder__AcVQX","FolderIcon":"Folder_FolderIcon__7D6tX"};